import { render, staticRenderFns } from "./purchaseArrivalNotice-add-or-update.vue?vue&type=template&id=4d5a36f4&scoped=true"
import script from "./purchaseArrivalNotice-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseArrivalNotice-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseArrivalNotice-add-or-update.vue?vue&type=style&index=0&id=4d5a36f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a36f4",
  null
  
)

export default component.exports